type DirVendor = {
    ID: number;
    vendorName?: string;
    hidden?: number | boolean;
};

type DirDimension = {
    ID: number;
    dimensionName?: string;
};

/** ID постачальника за замовчуванням («Невідомий» — ID = 0) */
export const resolveDefaultVendorId = (_vendors?: DirVendor[] | null): number => 0;

/** ID першої одиниці виміру зі списку */
export const resolveDefaultDimensionId = (dimensions?: DirDimension[] | null): number => {
    const first = (dimensions || []).find((dimension) => Number(dimension.ID) > 0);
    return Number(first?.ID || 0);
};
